import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { FaqState } from "./types";
import { RootState } from "@/store/types";

const Faq: Module<FaqState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default Faq;
